import { render, staticRenderFns } from "./icon.vue?vue&type=template&id=4b849bf2&"
import script from "./icon.vue?vue&type=script&lang=js&"
export * from "./icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yoreirei/Documents/project/other/market-ui/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b849bf2')) {
      api.createRecord('4b849bf2', component.options)
    } else {
      api.reload('4b849bf2', component.options)
    }
    module.hot.accept("./icon.vue?vue&type=template&id=4b849bf2&", function () {
      api.rerender('4b849bf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lib/icon/src/icon.vue"
export default component.exports